import localforage from 'localforage'

export interface StorageAdapter {
  getItem<T>(key: string): Promise<T | null>
  setItem<T>(key: string, value: T): Promise<T>
  removeItem(key: string): Promise<void>
}

export function createLocalForageAdapter(instance?: typeof localforage): StorageAdapter {
  const storage =
    instance ??
    localforage.createInstance({
      name: 'gongkao-knowledge',
      storeName: 'learning_data',
      description: '公考常识学习记录与用户设置',
    })

  return {
    getItem: <T>(key: string) => storage.getItem<T>(key),
    setItem: <T>(key: string, value: T) => storage.setItem(key, value),
    removeItem: (key: string) => storage.removeItem(key),
  }
}
